export default "__VITE_ASSET__CRQKJtQC__"